module.exports = __webpack_public_path__ + "static/media/components.49f83a64.png";